import React from "react";
import './background.scss'

function Background () {
    return (
        <div className="night">
        <div className="shooting_star"></div>
        <div className="shooting_star"></div>
        <div className="shooting_star"></div>
        <div className="shooting_star_red"></div>
        <div className="shooting_star"></div>
        <div className="shooting_star_red"></div>
        <div className="shooting_star"></div>
        <div className="shooting_star"></div>
        <div className="shooting_star_red"></div>
        <div className="shooting_star"></div>
        <div className="shooting_star"></div>
        <div className="shooting_star"></div>
        <div className="shooting_star"></div>
        <div className="shooting_star_red"></div>
        <div className="shooting_star"></div>
        <div className="shooting_star"></div>
        <div className="shooting_star_red"></div>
        <div className="shooting_star"></div>
        <div className="shooting_star_red"></div>
        <div className="shooting_star"></div>
    </div>
    )
}

export default Background